var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-table',{attrs:{"columns":_vm.columns,"dataSource":_vm.data,"scroll":{ x: 1500, y: 300 }}},[_c('a',{attrs:{"slot":"action","href":"javascript:;"},slot:"action"},[_vm._v("action")])])}
var staticRenderFns = []

export { render, staticRenderFns }